import { createContext } from "react";

export interface IAuthContext {
  /** Whether the authentication context is still loading. */
  loading: boolean;
  /** Whether authentication failed or not. */
  failed: boolean;
  /** Gets the logged in users email. */
  email?: string;
  /** Gets whether a user is authenticated. */
  isAuthenticated: boolean;
  /** Whether the user has consented to terms and conditions */
  hasConsented: boolean;
  /** Has the user been authorzied */
  isAuthorized: boolean;
  /** Logs in with a redirect. This will redirect the user to the authentication service. */
  resetAuth: () => void;
  loginWithRedirect: (redirect: string) => void;
  /** Logs the user out of the application. */
  logout: () => void;
}

const noProvider = () => {
  throw Error("The AuthProvider has not been initialised");
};

const initialContext: IAuthContext = {
  loading: false,
  failed: false,
  isAuthenticated: false,
  hasConsented: false,
  isAuthorized: false,
  resetAuth: noProvider,
  loginWithRedirect: noProvider,
  logout: noProvider,
};

const AuthContext = createContext(initialContext);

export default AuthContext;
